<template>
  <div class="exchangeLineItem">
    <div class="exchangeLineItem-container">
      <div class="exchangeLineItem--header">
        <h3>
          {{ heading }}
        </h3>
        <div class="exchangeLineItem--header-img-wrapper">
          <div
            :class="headingIconClass"
            class="exchangeLineItem--header-img-wrapper-img"
          />
        </div>
      </div>
      <div class="exchangeLineItem--content">
        <div class="exchangeLineItem--content--productImageContainer">
          <img
            :alt="productDisplayName || 'Part or Product Name'"
            :src="getProductImage"
          >
        </div>
        <ul class="exchangeLineItem--content--details">
          <li v-if="productDisplayName">
            <h3>
              {{ productDisplayName }}
            </h3>
          </li>
          <li v-if="productPartNumber">
            {{ productPartNumber }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
@import './style.scss';
</style>
